export const formatPercent = (value: number | null) => {
  if (value === null || value === undefined) return "-";
  return `${Math.round(value * 100)}%`;
};

export const formatCurrency = (value: number | null) => {
  if (value === null || value === undefined) return "-";
  return `$${Math.round(value).toLocaleString()}`;
};

export const formatNumber = (value: number | null) => {
  if (value === null || value === undefined) return "-";
  return Math.round(value).toLocaleString();
};

export const formatDate = (dateString: string | null) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
};
